import { render, staticRenderFns } from "./HomeLeftArrow.vue?vue&type=template&id=c4539d36"
import script from "./HomeLeftArrow.vue?vue&type=script&lang=js"
export * from "./HomeLeftArrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports